<script setup lang="ts">
    /**
     * 📘docs: https://onewoom.atlassian.net/wiki/spaces/ECOM/pages/1914044429
     */
    const props = defineProps<IWidgetProps<MemberGalleryData>>();
    const { cmsComponentProps } = useWidget(props);
</script>
<template>
    <mol-member-gallery v-bind="cmsComponentProps" />
</template>
